import { Paper, Stack } from "@mui/material";
import { Helpbar } from "../snack-bar";
import { useTheme } from "@quales/utils/theme";
import React from "react";
import { useWindowDimensions } from "@quales/utils/hooks";

interface SubHeaderProps {
  children: React.ReactNode;
  cookieName?: string;
  helpText?: string;
}

export const SubHeader = (props: SubHeaderProps) => {
  const theme = useTheme();
  const windowSize = useWindowDimensions();
  const { children, cookieName, helpText } = props;

  const handleHelpbarClose = () => {};

  return (
    <Stack
      id="Subheader"
      marginBottom={5}
      width={
        windowSize.width -
        theme.dimensions.totalAppDrawerWidth -
        theme.dimensions.pageMargin
      }
    >
      <Paper variant="outlined">
        {/* <Stack height={theme.dimensions.heightAppBar}></Stack> */}
        {cookieName && (
          <Stack sx={{ width: "100%" }}>
            <Helpbar
              cookieName={cookieName}
              message={helpText || ""}
              onClose={handleHelpbarClose}
            ></Helpbar>
          </Stack>
        )}
        <Stack
          width={"100%"}
          padding={2}
          id="SubHeaderInnerStack"
          height={"100%"}
        >
          {children}
        </Stack>
      </Paper>
    </Stack>
  );
};

export default SubHeader;
